import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { A11yModule } from '@angular/cdk/a11y';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { PanelComponent, PanelHeaderDirective } from './panel/panel.component';
import { DeviceDropdownComponent } from './device-dropdown/device-dropdown.component';
import { ResponsiveDropdownScaffoldComponent } from './dropdown/responsive-dropdown/responsive-dropdown-scaffold.component';
import { DropdownItemComponent } from './dropdown/dropdown-item/dropdown-item.component';
import { DropdownItemgroupComponent } from './dropdown/dropdown-itemgroup/dropdown-itemgroup.component';
import { DropdownItemgroupLabelComponent } from './dropdown/dropdown-itemgroup-label/dropdown-itemgroup-label.component';
import { DurationPickerComponent } from './duration-picker/duration-picker.component';
import { TimetableComponent } from './timetable/timetable.component';
import { SwitchComponent } from './switch/switch.component';
import { GenericModalComponent } from './modals/generic-modal/generic-modal.component';
import { MessageBoxContentComponent } from './modals/message-box-content/message-box-content.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { InfoPopupComponent } from './info-popup/info-popup.component';
import { PageHeaderComponent } from './page-header/page-header.component';
import { AgeselectComponent } from './ageselect/ageselect.component';
import { ColumnChartComponent } from './column-chart/column-chart.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { BtnLoadingDirective } from './directives/btn-loading/btn-loading.directive';
import { SpinnerComponent } from './loading-spinner/spinner/spinner.component';
import { NumberPickerComponent } from './number-picker/number-picker.component';
import { SortDirective } from './table/sort.directive';
import { SortHeaderComponent } from './table/sort-header/sort-header.component';
import { KindBadgeComponent } from './kind-badge/kind-badge.component';
import { BonusBadgeComponent } from './bonus-badge/bonus-badge.component';
import { AppIconComponent } from './app-icon/app-icon.component';
import {RouterModule} from '@angular/router';
import { MobileSpacerComponent } from './mobile-spacer/mobile-spacer.component';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {NotificationButtonComponent} from '@app/ui-components/notification-button/notification-button.component';
import {CheckboxComponent} from '@app/ui-components/checkbox/checkbox.component';
import { RadioboxComponent } from './radiobox/radiobox.component';
import { LimitBadgeComponent } from './limit-badge/limit-badge.component';
import { RoamingButtonComponent } from './roaming-button/roaming-button.component';
import { ScgContextmenuDirective } from './timetable/scg-contextmenu.directive';
import { LoadingProgressComponent } from './loading-progress/loading-progress.component';
import { MenuComponent } from './menu/menu/menu.component';
import { MenuItemComponent } from './menu/menu-item/menu-item.component';
import { MenuTriggerDirective } from './menu/menu-trigger/menu-trigger.directive';
import { MenuDividerComponent } from './menu/menu-divider/menu-divider.component';
import { DropdownDividerComponent } from './dropdown/dropdown-divider/dropdown-divider.component';
import { StatusledComponent } from './statusled/statusled.component';


@NgModule({
  declarations: [
    PanelComponent,
    PanelHeaderDirective,
    DeviceDropdownComponent,
    ResponsiveDropdownScaffoldComponent,
    DropdownItemComponent,
    DropdownItemgroupComponent,
    DropdownItemgroupLabelComponent,
    DropdownDividerComponent,
    DurationPickerComponent,
    TimetableComponent,
    SwitchComponent,
    GenericModalComponent,
    MessageBoxContentComponent,
    SpinnerComponent,
    LoadingSpinnerComponent,
    InfoPopupComponent,
    PageHeaderComponent,
    AgeselectComponent,
    ColumnChartComponent,
    DateRangePickerComponent,
    BtnLoadingDirective,
    NumberPickerComponent,
    SortDirective,
    SortHeaderComponent,
    KindBadgeComponent,
    BonusBadgeComponent,
    AppIconComponent,
    MobileSpacerComponent,
    NotificationButtonComponent,
    CheckboxComponent,
    RadioboxComponent,
    LimitBadgeComponent,
    RoamingButtonComponent,
    ScgContextmenuDirective,
    LoadingProgressComponent,
    MenuComponent,
    MenuItemComponent,
    MenuTriggerDirective,
    MenuDividerComponent,
    StatusledComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    PortalModule,
    OverlayModule,
    A11yModule,
    FontAwesomeModule,
    // ngx-bootstrap
    BsDropdownModule,
    TooltipModule,
    PaginationModule,
    BsDatepickerModule,
    ProgressbarModule.forRoot(),
    RouterModule
  ],
    exports: [
        // Components that will be used externally
        PanelComponent,
        PanelHeaderDirective,
        ResponsiveDropdownScaffoldComponent,
        DropdownItemComponent,
        DropdownItemgroupComponent,
        DropdownItemgroupLabelComponent,
        DropdownDividerComponent,
        DeviceDropdownComponent,
        DurationPickerComponent,
        TimetableComponent,
        SwitchComponent,
        GenericModalComponent,
        LoadingSpinnerComponent,
        InfoPopupComponent,
        // Doku Dierk: Komponente exportierbar machen, damit woanders aufgerufen werden kann
        PageHeaderComponent,
        AgeselectComponent,
        ColumnChartComponent,
        DateRangePickerComponent,
        BtnLoadingDirective,
        NumberPickerComponent,
        SortDirective,
        SortHeaderComponent,
        KindBadgeComponent,
        BonusBadgeComponent,
        AppIconComponent,
        MobileSpacerComponent,
        NotificationButtonComponent,
        CheckboxComponent,
        RadioboxComponent,
        LimitBadgeComponent,
        RoamingButtonComponent,
        LoadingProgressComponent,
        MenuComponent,
        MenuItemComponent,
        MenuTriggerDirective,
        MenuDividerComponent,
        StatusledComponent
    ]
})
export class UiComponentsModule { }
